import React from 'react';
import cyberSecurityImage from './img/AI.png';
import { Link } from 'react-router-dom';
const ISOAIMSPage = () => {
    return (
        <div className="ai-container">
            {/* Hero Section */}

            <section className="ai-hero">
                <div className="ai-hero-content">
                    <h1 className="ai-main-title">
                        <span className="ai-title-gradient">Ensuring Trustworthy AI through ISO 42001:2023</span>
                    </h1>
                </div>
                <div className="ai-hero-image">
                    <img src={cyberSecurityImage} alt="AI and Cybersecurity" />
                    <div className="ai-gradient-overlay"></div>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="ai-intro-overview mt-5">
                <div className="ai-section-container">
                    <h2 className="ai-section-title">Introduction</h2>
                    <div className="ai-divider"></div>
                    <ul className="ai-bullet-list">
                        <li>
                            The ISO/IEC 42001:2023 standard provides a framework for organizations to establish, implement, maintain, and continuously improve an AI Management System (AIMS)
                        </li>
                        <li>
                            AIMS ensures the responsible, ethical, and trustworthy development and usage of AI systems
                        </li>
                        <li>
                            It helps organizations manage risks associated with AI, build trust with stakeholders, and comply with relevant regulations.
                        </li>
                    </ul>
                </div>
            </section>



            {/* Intro Section */}
            <section className="ai-intro-section" style={{marginTop:'-50px'}}>
                <div className="ai-section-container">
                    <div className="ai-intro-header">
                        <h2 className="ai-section-title">AI Management Systems</h2>
                        <div className="ai-divider"></div>
                    </div>

                    <div className="ai-intro-columns">
                        <div className="ai-intro-block">
                            <p>
                                The regulation and responsible use of artificial intelligence (AI) has been a hot topic, prompting the release of NIST’s
                                AI Risk Management Framework, and EU AI Act to help organizations secure this emerging technology besides ISO 42001:2023.
                            </p>
                        </div>

                        <div className="ai-intro-block">
                            <p>
                                These standards will address the need to implement safeguards addressing the security, safety, privacy, fairness,
                                transparency, and data quality of AI systems throughout their life cycle including ISO/IEC 42001 and, EU AI Act.
                            </p>
                        </div>

                        <div className="ai-intro-block">
                            <p>
                                ISO is already well-known among those interested in cybersecurity, as it offers frameworks for the implementation of
                                different management systems that can help you improve different aspects of your organization. Now, through the release of
                                ISO 4200, ISO is getting into the AI game with what are the best practices for an AI management system (AIMS).
                            </p>
                        </div>

                        <div className="ai-intro-block">
                            <p>
                                Our compliance experts at <strong>Cyber Arcadia</strong> are well placed to support any organization in its journey to ISO 42001.
                                Below is our high-level approach to enable an organization on ISO 42001:
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            {/* AIMS Steps Section (NEWLY ADDED) */}
        <section className="ai-steps-section" style={{ padding: '2rem 1rem', marginTop: '-5%', backgroundColor: '#f9f9f9' }}>
  <div className="ai-section-container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
    {/* <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: '#222' }}>Steps to AI Readiness</h2> */}
    <ol style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {[
        {
          title: "Review your AI Strategy",
          content: `Are we outsourcing components for our AI systems or are we building our
            large language models (LLMs) in-house, intended uses of our AI systems,
            types of data our AI systems will process, store, transmit, etc., where will we
            source our model training data, and what are our data quality characteristics`,
        },
        {
          title: "Understand Your Resource Requirements",
          content: `Does your organization intend to build your AIMS using in-house expertise or
            will you need a third-party consultant`,
        },
        {
          title: "Educate your team",
          content: `Potential risks of the AI system, Policies and procedures governing the
            acceptable use and development of AI systems, and their role(s)`,
        },
        {
          title: "Assess Your Risk",
          content: `Help you determine the potential / reasonably foreseeable impact of your AI
            systems on individuals, groups of individuals, and/or societies`,
        },
        {
          title: "Document Control and Processes",
          content: `Once AI risk assessment process is completed including impact assessment.
            You can begin implementing controls that will help you mitigate the risks`,
        },
        {
          title: "Readiness / Internal Audit",
          content: `At this stage, we will perform a readiness audit, identify non-conformances,
            corrective actions, and fix them`,
        },
        {
          title: "Certification Audit from the certifying authority",
          content: `At this stage, we will invite the certification authority and walk them through
            the complete AIMS policy, process and procedures. We will face the audit
            and will involve your AI team on a need basis`,
        },
      ].map((step, index) => (
        <li key={index} style={{
          backgroundColor: '#fff',
          padding: '1.5rem',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          marginBottom: '1.5rem',
          borderLeft: '6px solid #007bff'
        }}>
          <strong style={{ fontSize: '1.1rem', color: '#333' }}>{index + 1}. {step.title}</strong>
          <p style={{ marginTop: '0.5rem', color: '#555', lineHeight: '1.6' }}>{step.content}</p>
        </li>
      ))}
    </ol>
  </div>
</section>


            <section className="ai-process-section" style={{
                padding: "2rem 1rem",
                fontFamily: "Arial, sans-serif"
            }}>
                <div className="ai-section-container" style={{
                    maxWidth: "1200px",
                    margin: "0 auto"
                }}>
                    <h2 className="ai-section-title" style={{
                        fontSize: "clamp(1.5rem, 5vw, 2rem)",
                        textAlign: "center",
                        marginBottom: "2rem",
                        color: "#333"
                    }}>
                        Our Offerings for ISO 42001
                    </h2>

                    <div className="ai-process-steps" style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2rem",
                        alignItems: "stretch"
                    }}>
                        {/* Left Column - Cards 1 & 2 */}
                        <div style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "2rem",
                            order: 1
                        }}>
                            {/* Card 1 */}
                            <div className="ai-process-card" style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "1.5rem",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                            }}>
                                <div className="ai-step-number" style={{
                                    fontSize: "1.8rem",
                                    fontWeight: "bold",
                                    color: "#4a6bff",
                                    marginBottom: "0.5rem"
                                }}>01</div>
                                <h3 style={{
                                    fontSize: "1.25rem",
                                    margin: "0.5rem 0 1rem",
                                    color: "#333"
                                }}>ISO 42001 Enablement</h3>
                                <p style={{ marginBottom: "1rem", lineHeight: "1.5", color: "#555" }}>
                                    This includes end-to-end services, as mentioned in steps 1 to 7 above.
                                </p>
                                <ul style={{
                                    paddingLeft: "1.25rem",
                                    marginBottom: "0",
                                    color: "#555"
                                }}>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>AI Policies, Process, and Procedures</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Training to identified stakeholders</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Conducting the Internal Audit to verify readiness of the organization</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Reporting of non-conformances and support in fixing them</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Face Certification audit along with stakeholders from the organization</li>
                                    <li style={{ lineHeight: "1.4" }}>Support in fixing the non-conformances reported in the Certification audit</li>
                                </ul>
                            </div>

                            {/* Card 2 */}
                            <div className="ai-process-card" style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "1.5rem",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                            }}>
                                <div className="ai-step-number" style={{
                                    fontSize: "1.8rem",
                                    fontWeight: "bold",
                                    color: "#4a6bff",
                                    marginBottom: "0.5rem"
                                }}>02</div>
                                <h3 style={{
                                    fontSize: "1.25rem",
                                    margin: "0.5rem 0 1rem",
                                    color: "#333"
                                }}>Gap Assessment</h3>
                                <p style={{ marginBottom: "1rem", lineHeight: "1.5", color: "#555" }}>
                                    This Covers Benchmarking current policies and processes against ISO 42001.
                                </p>
                                <p style={{
                                    fontWeight: "bold",
                                    marginBottom: "0.5rem",
                                    color: "#555"
                                }}><strong>Deliverable:</strong></p>
                                <ul style={{
                                    paddingLeft: "1.25rem",
                                    marginBottom: "0",
                                    color: "#555"
                                }}>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Gap Assessment Report</li>
                                    <li style={{ lineHeight: "1.4" }}>Roadmap to ISO 42001 along with tentative timelines</li>
                                </ul>
                            </div>
                        </div>

                        {/* Right Column - Card 3 */}
                        <div style={{
                            flex: 1,
                            display: "flex",
                            order: 2
                        }}>
                            <div className="ai-process-card ai-process-card-wide" style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "1.5rem",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                            }}>
                                <div className="ai-step-number" style={{
                                    fontSize: "1.8rem",
                                    fontWeight: "bold",
                                    color: "#4a6bff",
                                    marginBottom: "0.5rem"
                                }}>03</div>
                                <h3 style={{
                                    fontSize: "1.25rem",
                                    margin: "0.5rem 0 1rem",
                                    color: "#333"
                                }}>Risk Assessment</h3>
                                <p style={{ marginBottom: "1rem", lineHeight: "1.5", color: "#555" }}>
                                    To help you determine the potential / reasonably foreseeable impact of your AI systems on individuals, groups of individuals, and/or societies, effective AI system impact assessments analyze areas that include, but are not limited to, the following:
                                </p>
                                <ul style={{
                                    paddingLeft: "1.25rem",
                                    marginBottom: "1rem",
                                    color: "#555"
                                }}>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>AI system features, purpose, and uses (intended / unintended)</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Data information and quality (dataset characteristics, sourcing, etc.)</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Algorithms and model information (foreseeable risks / vulnerabilities, metrics used to validate system performance, model training criteria, etc.)</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Deployment environment (geographies served, pre-deployment checks like red teaming to identify system vulnerabilities, deployment constraints, etc.)</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Relevant interested parties (if your organization deploys a model, who is the AI system developer, and what is the shared responsibility breakdown)</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>Actual and potential benefits and harms (in areas like security, privacy, safety, environmental, etc.)</li>
                                    <li style={{ lineHeight: "1.4" }}>AI system failures, misuse, and abuse</li>
                                </ul>
                                <p style={{
                                    fontWeight: "bold",
                                    marginBottom: "0.5rem",
                                    color: "#555"
                                }}><strong>Deliverable:</strong></p>
                                <p>Risk Assessment Report, which includes</p>
                                <ul style={{
                                    paddingLeft: "1.25rem",
                                    marginBottom: "0",
                                    color: "#555"
                                }}>

                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>AI Risk Assessment</li>
                                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.4" }}>AI Risk Treatment</li>
                                    <li style={{ lineHeight: "1.4" }}>AI System Impact Assessment Report</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <style jsx>{`
        @media (min-width: 769px) {
            .ai-process-steps {
                flex-direction: row !important;
            }
            .ai-process-steps > div:first-child {
                order: unset !important;
            }
            .ai-process-steps > div:last-child {
                order: unset !important;
            }
        }
    `}</style>
            </section>





            {/* CTA Section */}
            <section className="ai-cta-section">
                <div className="ai-section-container">
                    <h2 className="ai-cta-title">Ready to Implement ISO 42001?</h2>
                    <p className="ai-cta-text">
                        Please connect us at <span className="ai-accent">info@cyberarcadia.in</span> for a focused discussion.
                    </p>
                    <div className="ai-cta-button-container">
                        <Link to="/contact" className="ai-cta-button">
                            Contact Our Team
                        </Link>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default ISOAIMSPage;